import React, { useLayoutEffect, useState } from 'react';
import EcoGoogleMap from './GoogleMap/EcoGoogleMap';
import CommunityImg from '../../Common/CommunityImg/CommunityImg';
import {default as EcoAllianceBadge} from '../../../images/eco-alliance-badge.svg';
import {default as EcoAllianceTree} from '../../../images/Marker_tree.svg';
import './EcoAllianceMap.scss';

const EcoAllianceMap = ({onClicked}) => {

  const [isMobile, setIsMobile] = useState(false);

  const onLocationSelection = marker => {
    onClicked(marker);
  }


  useLayoutEffect(() => {
    function updateSize() {
      setIsMobile(window.innerWidth < 820);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return (
    <>
      <div className="noissue__eco-alliance__map-section">
        <EcoGoogleMap onClicked={onLocationSelection} isMobile={isMobile} />
      </div>
      <div className="noissue__eco-alliance__header__map-marker-labels">
          <div className="label-item">
            <CommunityImg src={EcoAllianceBadge} alt="badge" />
            Eco Alliance Members
          </div>
          <div className="label-item">
            <CommunityImg src={EcoAllianceTree} alt="tree" />
            Trees Planted
          </div>
        </div>
    </>
  )
}

export default EcoAllianceMap;
